import { useMutation, useQuery } from '@tanstack/react-query';
import { Button, Card, Space } from 'antd';
import PageTitle from 'apps/home/components/PageTitle';
import ErrorMessage from 'common/ui/ErrorMessage';
import LoadingSpinner from 'common/ui/LoadingSpinner';
import { Link, useParams } from 'react-router-dom';

const AdminDetail = ({
  title,
  pageTitle,
  listUrl,
  apiCall,
  options = { title: 'View detail', deleteEnabled: false, editEnabled: true },
  ItemDetail,
  resourceName,
  extraActions,
}) => {
  const params = useParams();
  const { title: actionTitle, deleteEnabled, editEnabled } = options;

  const {
    data: response,
    isLoading,
    error: fetchItemError,
    refetch: refreshItem,
  } = useQuery({
    queryKey: [apiCall.detail.queryKey, params.id],
    queryFn: () => apiCall.detail.queryFn({ id: params.id }),
  });

  const item = response?.[resourceName || 'item'] || response;

  const { mutate: deleteItem, isPending: isDeleting } = useMutation({
    mutationFn: apiCall.delete?.queryFn,
  });

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (fetchItemError) {
    return <ErrorMessage {...fetchItemError} />;
  }

  return (
    <>
      <PageTitle
        title={pageTitle || `View ${title} detail` || actionTitle}
        backUrl={listUrl}
      />
      <Card
        extra={
          <Space>
            {editEnabled && (
              <Link className="" to={`${listUrl}/${params.id}/edit`}>
                <Button type="primary">Edit</Button>
              </Link>
            )}
            {extraActions?.(params.id, item)}
          </Space>
        }
      >
        <ItemDetail item={item} apiCall={apiCall} onRefresh={refreshItem} />
      </Card>
    </>
  );
};

export default AdminDetail;
